import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteProjectAction,
  fetchProjects,
} from "../../store/actions/projectAction";

function useProject() {
  const [isModalOpen, setModalOpen] = useState(false);

  const projects = useSelector((store) => store.project?.projects);

  const dispatch = useDispatch();

  const toggleModal = () => setModalOpen((prev) => !prev);

  const handleDelete = (id) => {
    dispatch(
      deleteProjectAction({
        id,
      })
    );
  };

  useEffect(() => {
    dispatch(fetchProjects({}));
  }, []);

  return {
    projects,
    isModalOpen,
    toggleModal,
    handleDelete,
  };
}

export default useProject;
